import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
// import apiService from "../../api/api.service";
import moment from "moment";


export default {
  name: 'insights',
  components: { pageheader },
  props: ['respData'],

  data () {
    return {
      input: {},
    search: "",

      isInsightsLoading:false,
      
        insightsList:[],
     
        responseData:{},
      header_insights:[  
        // { text: "Logo", value: "actionIcon", sortable: false, align: "left" },
      { text: "Name", value: "name" },
      { text: "Value", value: "value" },

      { text: "Unit", value: "unit" },
      // { text: "Last 24 hours", value: "24HrsData" },
      { text: "Last updated", value: "lastUpdated" },

     ]
    }
  },
  computed: {
    ...mapGetters(["roles"]),

  },
  mounted () {
    this.input = utils.getInputContent("insights", this.roles);
    // this.readInsightsFromApi();
    this.responseData = this.respData;
    this.insightsList = this.responseData.insights;

  },
  filters: {
  formatDates: function(value) {
    if (value) {
      const format = "YYYY-MM-DD";
      return moment(value).format(format);
    }
  }
},
  methods: {
    // async readInsightsFromApi(){
    //   this.isInsightsLoading = true;
    //   try{
    //     let response = await apiService.getInsightsList();
    //     if(response){
    //       this.isInsightsLoading = false;
    //       this.insightsList = response.data;
    //     }else{
    //       this.isInsightsLoading = false;
    //       this.insightsList = [];
    //     }
    //   }catch(err){
    //     console.log(err);
    //     this.isInsightsLoading = false;
    //     // this.insightsList = [];
    //     this.insightsList = [
    //       {
    //         name: "Engine Percent Load At Current Speed",
    //         value:"0.00",
    //        unit: "%" ,
    //        '24HrsData':"",
    //        lastUpdated:"3 months ago",
            
            
    //       },
    //       {
    //         name: "Actual Engine - Percent Torque",
    //         value:"0.00",
    //         unit: "%" ,
    //         '24HrsData':"",
    //         lastUpdated:"3 months ago",
            
            
    //       },
    //       {
    //         name: "Fuel User (total)",
    //         value:"3550.21",
    //        unit: "gal" ,
    //        '24HrsData':"",
    //        lastUpdated:"3 months ago",
            
            
    //       },
    //       {
    //         name: "After Perticular treatment Diesel Particulate  Differential Pressure",
    //         value:"0.50",
    //         unit: "psi" ,
    //        '24HrsData':"",
    //        lastUpdated:"3 months ago",
            
            
    //       },
    //       {
    //         name: "Altitude",
    //         value:"902.23",
    //        unit: "ft" ,
    //        '24HrsData':"",
    //        lastUpdated:"2 minutes ago",
            
            
    //       }
    //     ];
    //   }
    // }
  }
}


